export const UNIFIED_VIEWER_SCALE_MAX = 8;
export const UNIFIED_VIEWER_SCALE_MIN = 0.05;

export const DEFAULT_CONTAINER_WIDTH = 1000;
export const DEFAULT_CONTAINER_HEIGHT = 1000;
export const ZOOM_TO_FIT_MARGIN = 0.01;

export const MIXPANEL_TOKEN = '5c4d853e7c3b77b1eb4468d5329b278c';
